import {
} from './actions';

const initialState = {
};

export function homeReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    default:
      return state;
  }
}
